import { Table, TableCell, TableContainer, TableRow, Typography } from '@mui/material';
import React from 'react'
import FunctionsIcon from '@mui/icons-material/Functions';
import AddIcon from '@mui/icons-material/Add';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { selectLocationFromMaster } from 'src/features/staticDataSlice';

function AssetListItemVertical({ sumInsuredData, tableListDatas, groupDetails }) {
    const [locationMap, setLocationMap] = React.useState({});
    const locationMasterList = useSelector(selectLocationFromMaster);
    React.useEffect(() => {
        if (locationMasterList?.length) {
            const map = {};
            locationMasterList.forEach((loc) => {
                const parts = [loc.name];
                if (loc.address) parts.push(loc.address);
                if (loc.pin) parts.push(loc.pin);
                map[loc.name] = parts.join(', ');
            });

            setLocationMap(map);
        }
    }, [locationMasterList]);
    return (
        <TableContainer sx={{ mt: 0 }}>

            <Table
                size="small"
                aria-label="a dense table"
                className="sum_insured_table"
            >
                {sumInsuredData?.sumInsuredHeaderSorted.map((head) => {
                    return <TableRow>
                        <TableCell style={{ width: '36.3vw', paddingLeft: '16px' }}>
                            <div
                            // className={(head.isSuminsured || head.horizontalSum) ? 'suminsuredHead' : ''}
                            >
                                {/* {head.isSuminsured && <FunctionsIcon style={{ marginLeft: '-5px' }} />} */}
                                {/* {head.horizontalSum && <AddIcon style={{ marginLeft: '-5px' }} />} */}
                                {head.title ? head.title : head.sumInsuredHeader.title}
                                {head.description && <span>*</span>}
                            </div>

                        </TableCell>
                        {tableListDatas?.map((_, index) => {
                            return (
                                <React.Fragment
                                    key={index}
                                >


                                    {sumInsuredData?.sumInsuredHeaderSorted.map((item) => {
                                        const attr = item.sumInsuredHeader.attribute;
                                        const headAttr = head.sumInsuredHeader.attribute;
                                        const value = tableListDatas[index][attr];

                                        if (attr !== headAttr) return null;

                                        const dateFields = [
                                            'retroActiveDate',
                                            'journeyStartDate',
                                            'journeyEndDate',
                                            'expectedDateOfCommencementOfErection',
                                            'projectStartDateOfFirstConsignment',
                                            'yearOfManufacture',
                                            'dateOfCommencementOfTransit',
                                            'invoiceNoAndDate',
                                            'billOfLadingAndDate'
                                        ];

                                        const isDateField = dateFields.includes(attr);
                                        const isFinancialField = item.isSuminsured || item.horizontalSum;

                                        let displayValue = 'N/A';

                                        if (attr === 'location') {
                                            displayValue = locationMap[value];
                                        } else if (Array.isArray(value)) {
                                            displayValue = value.length
                                                ? value.map(v => {
                                                    if (isDateField) return moment(v).format('DD-MM-YYYY');
                                                    if (isFinancialField) {
                                                        return new Intl.NumberFormat('en-IN', {
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2,
                                                        }).format(Number(v ?? 0));
                                                    }
                                                    return v;
                                                }).join(', ')
                                                : 'N/A';
                                        } else if (value !== null && value !== undefined && value !== '') {
                                            if (isDateField) {
                                                displayValue = moment(value).format('DD-MM-YYYY');
                                            } else if (isFinancialField) {
                                                displayValue = new Intl.NumberFormat('en-IN', {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2,
                                                }).format(Number(value ?? 0));
                                            } else {
                                                displayValue = value;
                                            }
                                        }

                                        return (
                                            <TableCell key={attr} className="Pad3">
                                                {displayValue}
                                            </TableCell>
                                        );
                                    })}


                                </React.Fragment>
                            );
                        })}
                    </TableRow>
                })}
                {parseFloat(groupDetails.totalSumInsured) > 0 && sumInsuredData.showTotalSumInsured ? (
                    <TableRow>
                        <TableCell className='Pad3'

                        ><Typography variant="h5" style={{ marginTop: 9, textAlign: 'right' }}>
                                Total
                            </Typography></TableCell>
                        <TableCell className='Pad3' >
                            <Typography variant="h5" style={{ marginTop: 9, textAlign: 'left' }}>
                                : {new Intl.NumberFormat('en-IN', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                }).format(Number(groupDetails?.totalSumInsured ?? 0))}
                            </Typography>
                        </TableCell>
                    </TableRow>
                ) : null}

            </Table>

        </TableContainer>
    )
}

export default AssetListItemVertical